import React, { useState } from "react";
import {
  ChevronDown,
  HeartPulse,
  Zap,
  Droplet,
  Activity,
  Leaf,
  Shield,
  Battery,
  Bone,
} from "lucide-react";

const faqData = [
  {
    question: "L-Citrulline",
    // icon: <HeartPulse className="w-5 h-5 text-[#44576D] mr-2" />,
    answer:
      "Promotes healthy blood flow by boosting nitric oxide levels, helping improve stamina, endurance, and circulation. It plays a vital role in maintaining firm, lasting performance and heart health.",
  },
  {
    question: "Vitamin C",
    // icon: <Shield className="w-5 h-5 text-[#44576D] mr-2" />,
    answer:
      "Supports healthy arteries and strong cell walls, ensuring smooth blood circulation throughout the body. Its antioxidant properties protect against cellular damage and fatigue.",
  },
  {
    question: "L-Proline",
    // icon: <Zap className="w-5 h-5 text-[#44576D] mr-2" />,
    answer:
      "A powerful antioxidant that supports heart and sexual health by energizing cells, improving oxygen utilization, and enhancing endurance and vitality.",
  },
  {
    question: "CoQ10 (Coenzyme Q10)",
    // icon: <Battery className="w-5 h-5 text-[#44576D] mr-2" />,
    answer:
      "A powerful antioxidant that supports heart and sexual health by energizing cells, improving oxygen utilization, and enhancing endurance and vitality.",
  },
  {
    question: "Pine Bark Extract",
    // icon: <Leaf className="w-5 h-5 text-[#44576D] mr-2" />,
    answer:
      "Known for its ability to boost libido and improve circulation, Pine Bark Extract enhances nitric oxide production, leading to better vascular health and performance.",
  },
  {
    question: "L-Lysine",
    // icon: <Activity className="w-5 h-5 text-[#44576D] mr-2" />,
    answer:
      "Supports arterial flexibility and balanced cholesterol levels. It aids in tissue repair and plays a vital role in maintaining overall cardiovascular integrity.",
  },
  {
    question: "Magnesium",
    // icon: <Droplet className="w-5 h-5 text-[#44576D] mr-2" />,
    answer:
      "An essential mineral that helps relax blood vessels, supporting flexible arteries and improved blood flow. It also aids in energy production and muscle function.",
  },
  {
    question: "Vitamin K2",
    // icon: <Bone className="w-5 h-5 text-[#44576D] mr-2" />,
    answer:
      "Helps direct calcium to the bones instead of arteries, promoting healthy circulation and heart health. It works synergistically with Vitamin D and Magnesium to maintain optimal vascular balance.",
  },
];

const HomeSix = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (idx) => {
    setActiveIndex(idx === activeIndex ? null : idx);
  };

  return (
    <section
      className="py-2 px-2 sm:px-4 md:px-8 lg:px-16 w-[93%] mx-auto capitalize"
      style={{ fontFamily: "Segoe UI" }}
    >
      <div className='flex flex-col items-center justify-center '>
        <button className="bg-[#44576D] text-[#ffffff] font-semibold p-10 md:px-8 py-3 md:py-4 rounded-md shadow  text-base md:text-lg mt-4">
          Shop Now and Feel the Difference</button>
      </div>
      <h2 className="text-[32px] font-bold text-[#44576D] mb-4 leading-none mt-16">
        Ingredient
      </h2>
      <h3 className="text-[18px] font-light text-[#44576D] mb-6 leading-2">
        Potent Ingredients in Erexel Pro — 100% Completely Natural | Clinically
        Proven for Results
      </h3>

      <div className="space-y-4">
        {faqData.map((item, idx) => (
          <div
            key={idx}
            className="border border-gray-200 rounded overflow-hidden"
          >
            <button
              onClick={() => toggle(idx)}
              className={`w-full text-left px-5 py-3 flex justify-between items-center ${activeIndex === idx ? "bg-[#F4F6FC]" : "bg-white"
                } transition`}
              style={{ fontFamily: "Segoe UI" }}
            >
              <div className="flex items-center">
                {item.icon}
                <span className="text-[#44576D] text-[17px] font-semibold leading-normal">
                  {item.question}
                </span>
              </div>
              <ChevronDown
                className={`w-5 h-5 transform transition-transform duration-300 ${activeIndex === idx ? "rotate-180 text-[#44576D]" : "text-gray-600"
                  }`}
              />
            </button>
            {activeIndex === idx && (
              <div className="px-4 pb-4 pt-1 text-[#757575] text-[14px] font-medium leading-normal bg-[#F4F6FC]">
                {item.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default HomeSix;
